module.exports = __webpack_public_path__ + "img/index-kinds-book.f2b75c74.png";